import { LinkedOrganization, User } from 'models/user';
import { Organization } from 'models/organization';

/**
 * Role, active flag and organization are per-organization data in `linkedOrganizations`.
 * Root `user.role` is only a cache of the organization the user last signed in to, so it
 * goes stale as soon as an admin changes their role (DD-3619). Read the entry for the
 * organization the admin is working in, however many the user belongs to.
 *
 * Falls back to the root fields when no entry matches, so a row never renders a blank
 * role and status dot.
 */
export const resolveUserOrganization = (user: User, currentOrganizationId?: string): LinkedOrganization => {
    const rootOrganization: LinkedOrganization = {
        organization: user.organization as Organization,
        role: user.role,
        active: user.active || false,
        type: user.type,
    };
    if (!currentOrganizationId) {
        return rootOrganization;
    }
    const linkedOrganization = (user.linkedOrganizations || []).find(
        (candidate) => (candidate.organization as Organization)?._id === currentOrganizationId,
    );
    return linkedOrganization || rootOrganization;
};
